import React from "react";

/**
 * R6 A6 — Quick Filters Bar.
 * One-line chip row. Click once → apply. Click again → clear.
 */
const CHIPS = [
  { key: "my_overdue",       label: "My overdue",      filter: { nextContact: "past_due" } },
  { key: "due_today",        label: "Due today",       filter: { nextContact: "due_next" } },
  { key: "this_week",        label: "This week",       filter: { nextContact: "upcoming" } },
  { key: "no_next_contact",  label: "No next contact", filter: { noNext: "1" } },
  { key: "hot",              label: "Hot",             filter: { status: "Qualified" } },
  { key: "won_this_month",   label: "Won this month",  filter: { status: "Won" } },
];

export default function QuickFiltersBar({ activeKeys = [], onToggle }) {
  return (
    <div className="r6-quick-filters-bar">
      {CHIPS.map((c) => {
        const active = activeKeys.includes(c.key);
        return (
          <button
            key={c.key}
            type="button"
            className={`r6-quick-chip ${active ? "is-active" : ""}`}
            onClick={() => onToggle?.(c)}
            title={active ? "Clear filter" : "Apply filter"}
          >
            {c.label}
            {active && <i className="fas fa-times r6-quick-chip-x" />}
          </button>
        );
      })}
    </div>
  );
}

export { CHIPS as QUICK_FILTER_CHIPS };